import { render, staticRenderFns } from "./CustomAmountInput.vue?vue&type=template&id=3c556276&scoped=true"
import script from "./CustomAmountInput.vue?vue&type=script&lang=js"
export * from "./CustomAmountInput.vue?vue&type=script&lang=js"
import style0 from "./CustomAmountInput.vue?vue&type=style&index=0&id=3c556276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c556276",
  null
  
)

export default component.exports